import React from 'react'
import { Link } from 'react-router-dom'

import Logo from '../Logo'

import './index.css'
import BEMHelper from 'react-bem-helper'
const classes = new BEMHelper('menu')

export default function Menu () {
  const currentPath = window.location.pathname.split('/')
  const active = (slug) => currentPath.indexOf(slug) !== -1 ? 'active' : 'inactive'

  return (
    <nav {...classes('')}>
      <Logo {...classes('logo')} />

      <div {...classes('items')}>
        <Link to="/tjenester" {...classes('item', active('tjenester'))}>Tjenester</Link>
        <Link to="/arbeid" {...classes('item', active('arbeid'))}>Referanser</Link>
        <Link to="/medlemssystem" {...classes('item', active('medlemssystem'))}>Medlemssystem</Link>
        <Link to="/folka" {...classes('item', active('folka'))}>Folka</Link>
        {/*<Link to="/kontakt" {...classes('item', active('kontakt'))}>Kontakt</Link>*/}
      </div>


    </nav>
  )
}



// WEBPACK FOOTER //
// ./src/components/Menu/index.js